<style lang="less" scoped>
.chatBox {
  width: 1100px;
  height: calc(100vh - 150px);
  min-height: 320px;
  margin: 20px auto;
  display: flex;
  border-radius: @border-radius-base;
  background-color: @white;
  .left {
    padding: 20px 0;
    width: 250px;
    min-width: 250px;
    display: flex;
    flex-direction: column;
    overflow: scroll;
    .loading {
      position: absolute;
      top: 50%;
      left: 50%;
    }
    .group {
      padding: 15px 20px;
      border-bottom: dotted 1px #eee;
      font-size: 18px;
      font-weight: bold;
      cursor: pointer;
    }
    .group:hover {
      color: @primary-color;
    }
    .active {
      background-color: #f7f5f0;
      color: @primary-color;
    }
  }
  .mid {
    display: flex;
    flex-shrink: 0;
    flex-direction: column;
    width: 70px;
    align-items: center;
    background-color: #f7f5f0;
    padding: 20px 15px;
    .btn {
      width: 100%;
      margin-top: 10px;
      cursor: pointer;
    }
    .btn:hover {
      box-shadow: 0 0 5px #999;
    }
    .user-photo {
      width: 50px;
      height: 50px;
      margin-bottom: 30px;
      border-radius: 50%;
    }
  }
  .right {
    flex-grow: 1;
    overflow: auto;
  }
}
.addGroup {
  text-align: center;
  .addFun {
    margin-top: 16px !important;
  }
}
</style>
<template>
  <div class="chatBox">
    <div class="left">
      <a-spin class="loading" v-show="loading" />
      <div v-trigger :id="'nav'+index" v-for="(group,index) in groupLists" :key="group.groupTag" class="group"
           :class="currentGroupIndex===index?'active':'group'"
           @click="changeGroup(group.groupTag, index, group)">{{group.groupName}}</div>
      <div class="addGroup">
        <a-button class="addFun" @click="addGroup" type="primary">新建小组群</a-button>
      </div>
    </div>
    <div class="mid">
      <!-- <img v-if="shareData.classInfo.photo!=null" group="user-photo" :src="$userINfoBasePath+'/'+shareData.classInfo.photo"/> -->
      <router-link :to="{ name: 'Chat',params:{groupid:currentGroupId}}">
        <img class="btn" :src="`imgs/${currentModule==='Chat'?'1-02.png':'1-01.png'}`" />
      </router-link>
      <!-- <router-link :to="{ name: 'Notice',params:{groupid:currentGroupId}}">
        <img group="btn" :src="`imgs/${currentModule==='Notice'?'2-02.png':'2-01.png'}`"/>
      </router-link> -->
      <router-link :to="{ name: 'Member',params:{groupid:currentGroupId}}">
        <img class="btn" :src="`imgs/${currentModule==='Member'?'3-02.png':'3-01.png'}`" />
      </router-link>
      <router-link :to="{ name: 'ClassInfo',params:{groupid:currentGroupId}}">
        <img class="btn" :src="`imgs/${currentModule==='ClassInfo'?'4-02.png':'4-01.png'}`" />
      </router-link>
      <!-- <router-link :to="{ name: 'AddGroup',params:{groupid:currentGroupId}}">
        <img group="btn" :src="`imgs/${currentModule==='AddGroup'?'5-02.png':'5-01.png'}`"/>
      </router-link> -->
    </div>
    <div class="right">
      <router-view />
    </div>
    <!-- <iframe :src="url" frameborder="0" id="iframId" group="iframe"></iframe> -->
  </div>
</template>

<script>
import WebIM from '../../utils/WebIM';
import shareState from '../../utils/shareState.js';
export default {
  name: 'Class',
  computed: {
    groupLists: {
      get() {
        return this.$store.state.groupLists;
      },
      set() {
        return this.$store.state.groupLists;
      },
    },
  },
  watch: {
    $route() {
      this.currentModule = this.$route.name;
      // this.getClassMembers(this.currentGroupId)
      // localStorage.setItem('groupId',this.$route.params.groupid)
    },
    groupLists: {
      handler: function (val, oldval) {
        this.groupLists = val;
      },
      immediate: true,
    },
  },
  data() {
    return {
      loading: false,
      shareData: shareState.state,
      currentModule: 'Chat',
      currentGroupId: '',
      currentGroupIndex: 0,
      // url: 'myClass/index.html?userId=' + this.$getUserInfo().id
    };
  },
  beforeMount() {
   // this.getImInfo();
    // this.getCurrentGroup()
    this.getCurrentModule();
    this.getHistoryMsg();
  },
  mounted() {
    this.getMyClassNum();
    this.getV2Group();
  },
  methods: {
    changeModule(module) {
      this.currentModule = module;
    },
    getCurrentGroup() {
      localStorage.setItem('data', JSON.stringify(this.groupLists));
      // console.log('data',localStorage.getItem('data'))
      // console.log(this.shareData.imUserInfo)
      this.currentGroupId = this.$route.params.groupid;
      if (this.currentGroupId) {
        this.getClassMembers(this.currentGroupId);
        return;
      }
      if (this.groupLists && this.groupLists.length > 0) this.currentGroupId = this.groupLists[0].groupid;
      this.getClassMembers(this.currentGroupId);
    },
    getCurrentModule() {
      this.currentModule = this.$route.name;
      if (this.currentModule === 'Class') this.$router.push({ path: `class/chat/${this.currentGroupId}` });
    },
    getImInfo() {
      // 获取用户IM注册信息
      if (this.shareData.imUserInfo) {
        this.loginWebIm();
        return;
      }
      this.$fetch({
        url: this.$httpConfig.getUserLoginToken,
      })
        .loading(() => (this.loading = true))
        .done((res) => {
          if (res && res.success && res.resultData) {
            shareState.setImUserInfo({
              access_token: res.resultData.access_token,
              expires_in: res.resultData.expires_in,
              user: res.resultData.user,
            });
            // this.loginWebIm();
          }
        });
    },
    updateMessages(message, msgType) {
      const stu = this.shareData.myClassStudents.find((student) => student.id === message.from);
      const fromUserName = stu?.userName || message.from;
      const fromUserPhoto = stu?.photo ? this.$userINfoBasePath + '/' + stu?.photo : 'imgs/logo.png';
      const receivedMsg = Object.assign(message, {
        msg: msgType === 'txt' ? message.sourceMsg : message.url,
        fromUserName,
        fromUserPhoto,
        chatType: 'groupChat',
        msgType: msgType,
        bySelf: false,
        status: 'received',
      });
      shareState.setMsgList(receivedMsg);
    },
    loginWebIm() {
      const options = {
        apiUrl: WebIM.config.apiURL,
        user: this.shareData.imUserInfo.user.username,
        accessToken: this.shareData.imUserInfo.access_token,
        appKey: WebIM.config.appkey,
      };
      const vm = this;
      WebIM.conn.open(options);
      WebIM.conn.listen({
        onOpened: function (message) {
          // 连接成功回调
          vm.loading = false;
          // vm.getGroupList()
        },
        onTextMessage: function (message) {
          // 收到文本消息
          vm.updateMessages(message, 'txt');
          console.log('收到文本消息', message.time.length, message)
        },
        onPictureMessage: function (message) {
          // 接收图片消息
          vm.updateMessages(message, 'img');
          console.log('收到图片消息', message);
        },
        onAudioMessage: function (message) {
          // 收到音频消息
          console.log('收到音频消息', message);
          vm.updateMessages(message, 'audio');
        },
        onFileMessage: function (message) {
          // 收到文件消息
          console.log('收到文件消息', message);
          vm.updateMessages(message, 'file');
        },
        onVideoMessage: function (message) {
          // 收到视频消息
          console.log('收到视频消息', message);
          vm.updateMessages(message, 'video');
        },
        onRecallMessage: function (message) {
          // 收到消息撤回回执
          console.log('收到消息撤回回执', message);
        },
      });
    },
    getGroupList() {
      var options = {
        success: (res) => {
          this.currentGroupId = res.data.length > 0 && res.data[0].groupid;
          this.$router.push({ path: `/class/chat/${this.currentGroupId}` });
        },
        error: (e) => {
          this.$message.error('获取群组失败！');
          this.getGroupList();
        },
      };
      WebIM.conn.getGroup(options);
    },
    changeGroup(groupid, index, group) {
      this.currentGroupIndex = index;
      this.$store.commit('setCurrentGroupMess', group);
      this.$store.commit('setCurrentGroupId', groupid);
      this.currentGroupId = groupid;
      const reg = /\/\d+$/;
      const cPath = this.$route.path.replace(reg, '');
      const cPath1 = cPath.toString().replace('/undefined', '');
      this.$router.push({ path: `${cPath1}/${groupid}` });
    },
    // getClassMembers (groupid) {
    //   const myClass = this.$getUserInfo().group.filter(c => c.groupTag === groupid)
    //   if (myClass.length > 0) {
    //     myClass[0].students.push({
    //       id: myClass[0].teaId,
    //       userName: myClass[0].teaName
    //     })
    //     shareState.setMyClassStudents(myClass[0].students)
    //   }
    // },
    getHistoryMsg() {
      if (!localStorage.getItem('syzgImMsg')) return;
      const historyMsgs = JSON.parse(localStorage.getItem('syzgImMsg'));
      shareState.setMsgList(historyMsgs, true);
      if (!historyMsgs) return;
      this.$store.commit('setMsgList', historyMsgs);
    },
    getMyClassNum() {
      // 获取我的班级列表
      const _this = this;
      _this
        .$fetch({
          url: _this.$baseUrl + 'ebook/class/common/getMyClassInfo',
          body: { userId: _this.$getUserInfo().id },
        })
        .done((res) => {
          if (res && res.success && res.resultCode === 0) {
            _this.classData = res.resultData;
            shareState.setClassInfo(_this.classData);
          }
        });
    },
    addGroup() {
      // 新建小组页面
      this.$router.push({ name: 'AddGroup' });
    },
    getV2Group () {
      // 根据班级id 获取小组--重新拆分接口，减少原大接口耗时
      const _this = this
      _this.$fetch({
        url: _this.$baseUrl + 'ebook/class/common/v2/getV2ClassGroup',
        body: { classId: localStorage.getItem('classID') }
      })
        .done((res) => {
          if (res && res.success && res.resultCode === 0) {
            _this.groupLists = res.resultData
            _this.$store.commit('setGroupLists', res.resultData)
            shareState.setImGroupList(res.resultData)
            console.log('getV2Group')
            console.log(res)
            console.log(_this.$store)
          }
        })
    },
  },
  directives: {
    trigger: {
      inserted(el, binging) {
        el.id == 'nav0' ? el.click() : null;
      },
    },
  },
};
</script>
